import { createContext } from 'react';

const noop = () => {};
export const SELECT_ANCILLARIES_INITIAL_STATE = {
  data: null,
  errors: null,
  loading: false,
  mutate: noop,
};

export const SelectAncillariesContext = createContext(
  SELECT_ANCILLARIES_INITIAL_STATE
);
